import { IThemeColors } from '@wyz/types';
import clsx from 'clsx';
import * as React from 'react';
type BuiltInProps = Pick<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'onDoubleClick'
>;
type Props = {
  bg: IThemeColors;
  pill?: boolean;
  className?: string;
  id?: string;
} & BuiltInProps;

const SoftBadge = ({
  bg = 'primary',
  pill,
  children,
  className,
  id,
  ...rest
}: React.PropsWithChildren<Props>) => {
  return (
    <div
      {...rest}
      className={clsx(className, `badge badge-soft-${bg}`, {
        'rounded-pill': pill,
      })}
      id={id}
      data-cy={id}
    >
      {children}
    </div>
  );
};

export default SoftBadge;
